// import { ref } from 'vue'
export default {
  methods: {
    showSelectUserDialog(title, url, extraToolbar, extraColumns) {
      var toolbarAddUser = {
        formItems: [
          {
            label: '账号',
            prop: 'id',
            cp: this.$ComparePatterns.Matchs,
            bind: { style: 'width: 120px' }
          },
          {
            label: '姓名',
            prop: 'nick_name',
            cp: this.$ComparePatterns.Matchs,
            bind: { style: 'width: 120px' }
          }
        ],
        ...(extraToolbar || {})
      }
      var columnsAddUser = [
        { bind: { label: '账号', prop: 'id' } },
        { bind: { label: '姓名', prop: 'nick_name' } },
        {
          bind: { label: '状态', prop: 'disabled' },
          default: {
            component: 'user-state'
          }
        },
        ...(extraColumns || [])
      ]
      // var dd = ref('')
      var content = () => {
        return (
          <base-table
            style='height: 400px'
            url={url}
            toolbar={toolbarAddUser}
            columns={columnsAddUser}
          ></base-table>
        )
      }
      var bind = {
        title: title,
        showCancel: false,
        showOk: false
      }
      var $baseDialog = this.$showNewBaseDialog(content, bind, {})
      return $baseDialog
    }
  }
}
